import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Captcha from './Captcha'; // فرض می‌کنیم کپچا یک کامپوننت قابل استفاده است
import BASE_URL from '../../config/config';
import { useAuth } from "./AuthContext";
import aiLogo from "../../assets/ai-logo.png";
import "../../css/loginForm.css";

export default function SignUp() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(null);
  const [isEmailAvailable, setIsEmailAvailable] = useState(null);
  const [isPhoneAvailable, setIsPhoneAvailable] = useState(null);
  const [csrfToken, setCsrfToken] = useState('');
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth(); // ✅ دریافت user از context

  // ✅ ریدایرکت اگر کاربر قبلاً لاگین کرده باشد
  useEffect(() => {
    if (user) {
      // اگر کاربر ادمین بود، به /admin، وگرنه به /dashboard
      if (user.role === "admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [user, navigate]);


  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  const checkAvailability = async (field, value) => {
    if (value) {
      try {
        const response = await fetch(`${BASE_URL}/check-${field}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          credentials: 'include',
          body: JSON.stringify({ [field]: value }),
        });
        const data = await response.json();
        if (response.ok) {
          if (field === 'username') setIsUsernameAvailable(data.available);
          else if (field === 'email') setIsEmailAvailable(data.available);
          else if (field === 'phone') setIsPhoneAvailable(data.available);
        }
      } catch (error) {
        console.error('Error checking availability:', error);
      }
    }
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const persianArabicRegex = /[\u0600-\u06FF]/;
    return regex.test(email) && !persianArabicRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    if (!validateEmail(emailValue)) {
      setMessage('لطفاً یک ایمیل معتبر وارد کنید. هیچ کاراکتر فارسی مجاز نیست.');
    } else {
      setMessage('');
    }
    checkAvailability('email', emailValue);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setPhone(value);
      const phoneValidation = /^09\d{9}$/;
      if (phoneValidation.test(value)) {
        checkAvailability('phone', value);
        setMessage('');
      } else {
        setMessage('شماره موبایل باید 11 کاراکتر باشد و با 09 شروع شود.');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!captchaVerified) {
      setMessage('لطفاً کد امنیتی را تأیید کنید.');
      setIsLoading(false);
      return;
    }

    if (username.length < 3 || !/^[a-zA-Z0-9]+$/.test(username)) {
      setMessage('نام کاربری باید حداقل 3 کاراکتر و فقط شامل حروف انگلیسی و اعداد باشد');
      setIsLoading(false);
      return;
    }

    if (!validateEmail(email)) {
      setMessage('لطفاً یک ایمیل معتبر وارد کنید. هیچ کاراکتر فارسی مجاز نیست.');
      setIsLoading(false);
      return;
    }

    if (!isEmailAvailable) {
      setMessage('این ایمیل قبلاً گرفته شده است.');
      setIsLoading(false);
      return;
    }

    const phoneValidation = /^09\d{9}$/;
    if (!phoneValidation.test(phone)) {
      setMessage('شماره موبایل باید 11 کاراکتر باشد و با 09 شروع شود.');
      setIsLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setMessage('رمز عبور و تأیید رمز عبور مطابقت ندارد.');
      setIsLoading(false);
      return;
    }

    const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordValidation.test(password)) {
      setMessage('رمز عبور باید حداقل 8 کاراکتر، شامل حروف بزرگ و کوچک، اعداد و علامت‌ها باشد.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'CSRF-Token': csrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ username, email, password, phone }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage('ثبت نام موفقیت‌آمیز بود!');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('خطا در برقراری ارتباط با سرور. لطفاً بعداً تلاش کنید.');
    } finally {
      setIsLoading(false);
    }
  };

  if (user) {
    return null; // یا یک اسپینر کوچک در حین ریدایرکت
  }

  return (
    <div className="bg-gray-50 min-h-screen flex items-center justify-center py-12 px-4">
      <div className="login-container max-w-4xl w-full mx-auto overflow-hidden rounded-2xl shadow-lg bg-white">
        {/* Left Side - توضیحات */}
        {/* Right Side - فرم */}
        <div className="login-right p-12 flex flex-col justify-center space-y-6">
            <div className="logo-sing mb-6">
              <img src={aiLogo} alt="لوگو" className="w-16 h-16 mx-auto mb-2" />
              <p className="text-center text-dark font-bold text-lg">هوش جدید </p>
            </div>
            <h2 className="text-3xl font-bold text-center text-[#140a46] mb-6">ثبت‌نام</h2>

            <form onSubmit={handleSubmit} className="space-y-4 form-auth">
              {/* نام کاربری */}
              <div className="space-y-1">
                <input
                  type="text"
                  placeholder="نام کاربری"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    checkAvailability('username', e.target.value);
                  }}
                  className="form-input w-full p-4 border-2 border-gray-200 rounded-xl focus:border-[#00a0dc] focus:ring-2 focus:ring-[#00a0dc]/20 transition-all"
                  required
                />
                {isUsernameAvailable !== null && (
                  <p className={`text-sm ${isUsernameAvailable ? 'text-green-600' : 'text-red-600'}`}>
                    {isUsernameAvailable ? '✅ نام کاربری آزاد است.' : '❌ این نام کاربری قبلاً گرفته شده است.'}
                  </p>
                )}
              </div>

              {/* ایمیل */}
              <div className="space-y-1">
                <input
                  type="email"
                  placeholder="ایمیل"
                  value={email}
                  onChange={handleEmailChange}
                  className="form-input w-full p-4 border-2 border-gray-200 rounded-xl focus:border-[#00a0dc] focus:ring-2 focus:ring-[#00a0dc]/20 transition-all"
                  required
                />
                {isEmailAvailable !== null && (
                  <p className={`text-sm ${isEmailAvailable ? 'text-green-600' : 'text-red-600'}`}>
                    {isEmailAvailable ? '✅ ایمیل آزاد است.' : '❌ این ایمیل قبلاً گرفته شده است.'}
                  </p>
                )}
              </div>

              {/* شماره موبایل */}
              <div className="space-y-1">
                <input
                  type="tel"
                  placeholder="شماره موبایل (09121234567)"
                  value={phone}
                  onChange={handlePhoneChange}
                  maxLength={11}
                  className="form-input w-full p-4 border-2 border-gray-200 rounded-xl focus:border-[#00a0dc] focus:ring-2 focus:ring-[#00a0dc]/20 transition-all"
                  required
                />
                {isPhoneAvailable !== null && (
                  <p className={`text-sm ${isPhoneAvailable ? 'text-green-600' : 'text-red-600'}`}>
                    {isPhoneAvailable ? '✅ شماره موبایل آزاد است.' : '❌ این شماره موبایل قبلاً گرفته شده است.'}
                  </p>
                )}
              </div>

              {/* رمز عبور */}
              <input
                type="password"
                placeholder="رمز عبور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input w-full p-4 border-2 border-gray-200 rounded-xl focus:border-[#00a0dc] focus:ring-2 focus:ring-[#00a0dc]/20 transition-all"
                required
              />
              <input
                type="password"
                placeholder="تایید رمز عبور"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-input w-full p-4 border-2 border-gray-200 rounded-xl focus:border-[#00a0dc] focus:ring-2 focus:ring-[#00a0dc]/20 transition-all"
                required
              />

              {/* کپچا */}
              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <Captcha onVerify={setCaptchaVerified} />
              </div>

              {/* پیام خطا/موفقیت */}
              {message && (
                <p
                  className={`text-center text-sm p-2 rounded-lg ${message.includes('موفقیت') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    }`}
                >
                  {message}
                </p>
              )}

              {/* دکمه ثبت‌نام */}
              <button
                type="submit"
                disabled={isLoading || !captchaVerified}
                className="w-full btn-primary mt-4 py-3 rounded-xl font-bold"
              >
                {isLoading ? 'در حال ارسال...' : 'ثبت‌نام'}
              </button>
            </form>

            {/* دکمه ورود */}
            <button
              onClick={() => navigate('/login')}
              className="cta-login extra-button mt-6 "
            >
              🔐 قبلاً حساب دارید؟ وارد شوید
            </button>
          </div>
        </div>
      </div>
      );
}